import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HistoryService {
  private _previousUrl: string;
  private _currentUrl: string;
  private _initialRedirectUrl: string;
  private _excludedUrls = [];

  constructor(private readonly router: Router) {
    this._currentUrl = this.router.url;
    router.events
      .pipe(filter((event) => event instanceof NavigationEnd && !this.isExcludedUrl(event.urlAfterRedirects)))
      .subscribe((event: NavigationEnd) => {
        this._previousUrl = this._currentUrl;
        this._currentUrl = event.url;
      });
  }

  public initialize(excludedUrls: Array<string>): void {
    this._excludedUrls = excludedUrls;
  }

  public get previousUrl(): string {
    return this._initialRedirectUrl ? this._initialRedirectUrl : this._previousUrl;
  }

  public set initialRedirectUrl(url: string) {
    this._initialRedirectUrl = url;
  }

  public get currentUrl(): string {
    return this._currentUrl;
  }

  public clearHistory(): void {
    this._currentUrl = undefined;
    this._previousUrl = undefined;
  }

  private isExcludedUrl(url: string): boolean {
    return this._excludedUrls.some((excluded) => url.endsWith(excluded));
  }
}
